// main tools
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

// components
import { RequestPasswordResetForm } from '@dr-keyword-organisms/auth/form/request-password-reset'
import { LoginForm } from '@dr-keyword-organisms/auth/form/login'
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Hero } from '@dr-keyword-organisms/auth/hero'
import { Modal } from '@centria-ui-molecules/modal'

// assets
import LoginPicture from '@dr-keyword-public/assets/images/login/picture.jpg'

// bootstrap components
import { Container, Row, Col } from 'react-bootstrap'

// styles
import classes from '@dr-keyword-styles/pages/auth/login.module.scss'

// types
import type { NextPage } from 'next'

const LoginPage: NextPage = () => {
  const { t } = useTranslation()
  const [showDialog, setShowDialog] = useState(false)
  const [showForgottenPassword, setShowForgottenPassword] = useState(false)

  /**
   * @description Function to handle the modal visibility
   */
  const handleShowDialog = () => setShowDialog(!showDialog)

  /**
   * @description Function to handle the visibility of the forgotten password form
   */
  const handleShowForgottenPassword = () =>
    setShowForgottenPassword(!showForgottenPassword)

  return (
    <>
      <Container className={classes.container}>
        <Row className='h-100 m-0 align-items-center justify-content-evenly'>
          <Col xs={12} sm={6} lg={4} className={classes.form}>
            <div className='mb-4 d-flex justify-content-center'>
              <IconComponent icon='DrKeywordLogoIcon' size='login' />
            </div>

            {!showForgottenPassword ? (
              <LoginForm
                handleShowForgottenPassword={handleShowForgottenPassword}
              />
            ) : (
              <RequestPasswordResetForm
                handleShowForgottenPassword={handleShowForgottenPassword}
              />
            )}
          </Col>
          <Col xs={12} md={6} className={classes.hero}>
            <Hero
              backgroundImage={LoginPicture}
              mobileAction={{
                label: t('login-page.action-button'),
                action: handleShowDialog
              }}
              quote={{
                label: t('login-page.quote.text'),
                author: t('login-page.quote.author')
              }}
            />
          </Col>
        </Row>
      </Container>
      <Modal onHide={handleShowDialog} visible={showDialog}>
        {!showForgottenPassword ? (
          <LoginForm
            handleShowForgottenPassword={handleShowForgottenPassword}
          />
        ) : (
          <RequestPasswordResetForm
            handleShowForgottenPassword={handleShowForgottenPassword}
          />
        )}
      </Modal>
    </>
  )
}

export default LoginPage
